<sftp-admin-gui *ngIf="!error; else errorPage">
  <p-toast></p-toast>
  <app-menubar></app-menubar>
  <app-navbar></app-navbar>
</sftp-admin-gui>
<ng-template #errorPage>
  <app-error-handler [error]="error"></app-error-handler>
</ng-template>
